import React from 'react';
import MkBadge from './MkBadge';
import MkBtn from './MkBtn';
import { BMB_IOS_URL, bmbPlayHref } from '../../marketing/links';
import { mkTrack } from '../../marketing/track';

/**
 * Bring Me Back store CTA (spec §4.2). App Store first, then Play. On phones only that phone's
 * badge shows, plus a text link to the other store. `variant="button"` is the text-button form used
 * everywhere the App Store badge budget (one per page per platform) is already spent.
 * `selfHref` (e.g. "#get") replaces the desktop /bring-me-back link when already on that page.
 */
const BmbCta = ({ placement, platform, variant = 'badges', selfHref, className }) => {
  const cls = ['mk-cta', 'mk-cta--bmb', className].filter(Boolean).join(' ');
  const trackStore = (store, suffix = '') => () => mkTrack('store_click', `bmb:${store}:${placement}${suffix}`);

  if (variant === 'button') {
    if (platform === 'android') {
      return (
        <div className={cls}>
          <MkBtn variant="bmb" href={bmbPlayHref(placement)} sub="Google Play" onClick={trackStore('play')}>
            Get Bring Me Back
          </MkBtn>
        </div>
      );
    }
    if (platform === 'ios') {
      return (
        <div className={cls}>
          <MkBtn variant="bmb" href={BMB_IOS_URL} sub="App Store" onClick={trackStore('appstore')}>
            Get Bring Me Back
          </MkBtn>
        </div>
      );
    }
    if (selfHref) {
      return (
        <div className={cls}>
          <MkBtn variant="bmb" href={selfHref} onClick={() => mkTrack('cta_click', `bmb_anchor:${placement}`)}>
            See Bring Me Back
          </MkBtn>
        </div>
      );
    }
    return (
      <div className={cls}>
        <MkBtn variant="bmb" to="/bring-me-back" onClick={() => mkTrack('cta_click', `bmb_page:${placement}`)}>
          See Bring Me Back
        </MkBtn>
      </div>
    );
  }

  const appStore = (
    <MkBadge
      store="appstore"
      href={BMB_IOS_URL}
      alt="Download Bring Me Back on the App Store"
      onClick={trackStore('appstore')}
    />
  );
  const play = (
    <MkBadge
      store="play"
      href={bmbPlayHref(placement)}
      alt="Get Bring Me Back on Google Play"
      onClick={trackStore('play')}
    />
  );

  if (platform === 'android') {
    return (
      <div className={cls}>
        <div className="mk-badges">{play}</div>
        <a className="mk-badges__alt" href={BMB_IOS_URL} onClick={trackStore('appstore', '_alt')}>
          Also on the App Store for iPhone
        </a>
      </div>
    );
  }
  if (platform === 'ios') {
    return (
      <div className={cls}>
        <div className="mk-badges">{appStore}</div>
        <a className="mk-badges__alt" href={bmbPlayHref(placement)} onClick={trackStore('play', '_alt')}>
          Also on Google Play for Android
        </a>
      </div>
    );
  }
  return (
    <div className={cls}>
      <div className="mk-badges">
        {appStore}
        {play}
      </div>
    </div>
  );
};

export default BmbCta;
